// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__E9zBX","footer":"ChangeClinic_footer__5Zzxt"};